/* eslint-disable*/
/* eslint-disable import/prefer-default-export */
import Flowit from "../../../services/flowit";

import * as types from "./types";

// calling charts individually
export const loadBillingChart = ({ commit, state }) => {
  const filter = {
    start_at: state.chartsBeginDate,
    end_at: state.chartsEndDate,
    scope: state.chartScope
  };
  Flowit.account.getBillingChart(filter).then(response => {
    commit(types.BILLING_CHART, response.data.billing_chart);
    commit(types.UPDATE_CHARTS, false);
  });
};

export const loadTicketChart = ({ commit, state }) => {
  const filter = {
    start_at: state.chartsBeginDate,
    end_at: state.chartsEndDate,
    scope: state.chartScope
  };
  Flowit.account.getAverageTicket(filter).then(response => {
    commit(types.AVERAGE_TICKET, response.data.average_ticket);
    commit(types.UPDATE_CHARTS, false);
  });
};

export const loadKindChart = ({ commit, state }) => {
  const filter = {
    start_at: state.chartsBeginDate,
    end_at: state.chartsEndDate,
    scope: state.chartScope
  };
  Flowit.account.getPaymentKind(filter).then(response => {
    commit(types.PAYMENT_KIND, response.data.payment_kind);
    commit(types.UPDATE_CHARTS, false);
  });
};
export const loadBrandChart = ({ commit, state }) => {
  const filter = {
    start_at: state.chartsBeginDate,
    end_at: state.chartsEndDate,
    scope: state.chartScope
  };
  Flowit.account.getBrandChart(filter).then(response => {
    commit(types.BRAND_CHART, response.data.brand_chart);
    commit(types.UPDATE_CHARTS, false);
  });
};
/*end of calling charts*/

export const loadWeeklySchedule = ({ commit }) => {
  Flowit.dashboard.weeklySchedule().then(response => {
    commit(types.WEEKLY_SCHEDULE, response.data.weekly_schedule);
  });
};

export const loadBalance = ({ commit }) => {
  Flowit.account.getSummary().then(response => {
    commit(types.SUMMARY, response.data.summary);
  });
};

export const loadAccount = ({ commit }) => {};
/* eslint-disable */
export const getSummary = ({ commit }) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.account.getSummary().then(response => {
    commit(types.GET_SUMMARY, response.data.summary);
    commit(types.LOAD, false);
  });
};

export const getWeeklySchedule = ({ commit }) => {
  commit(types.LOAD, true);
  Flowit.dashboard.weeklySchedule().then(response => {
    commit(types.GET_WEEKLY_SCHEDULE, response.data.weekly_schedule);
    commit(types.LOAD, false);
  });
};

export const getBillingChart = ({ commit }, filter) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.account.getBillingChart(filter).then(response => {
    commit(types.GET_BILLING_CHART, response.data.billing_chart);
    commit(types.LOAD, false);
  });
};

export const getAverageTicket = ({ commit }, filter) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.account.getAverageTicket(filter).then(response => {
    commit(types.GET_AVERAGE_TICKET, response.data.average_ticket);
    commit(types.LOAD, false);
  });
};

export const getPaymentKind = ({ commit }, filter) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.account.getPaymentKind(filter).then(response => {
    commit(types.GET_PAYMENT_KIND, response.data.payment_kind);
    commit(types.LOAD, false);
  });
};

export const getBrandChart = ({ commit }, filter) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.account.getBrandChart(filter).then(response => {
    commit(types.GET_BRAND_CHART, response.data.brand_chart);
    commit(types.LOAD, false);
  });
};

export const getWallet = ({ commit }) => {
  commit(types.LOAD, true);
  Flowit.wallet.getWallet().then(response => {
    commit(types.GET_WALLET, response.data || {});
    commit(types.LOAD, false);
  }).catch(error => {
    console.error('Error fetching wallet:', error);
    commit(types.GET_WALLET, {});
    commit(types.LOAD, false);
  });
};
